// <s-doc-toc> — highlights the table-of-contents link for the section currently in view.
class SDocToc extends HTMLElement {
  #observer;

  connectedCallback() {
    const links = [...this.querySelectorAll('[data-toc-link]')];
    const targets = links
      .map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
      .filter(Boolean);
    if (!targets.length) return;

    const setCurrent = (id) => {
      links.forEach((link) => {
        if (link.hash === `#${id}`) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };

    this.#observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting);
      if (visible.length) setCurrent(visible[0].target.id);
    }, { rootMargin: '-20% 0px -70% 0px' });
    targets.forEach((target) => this.#observer.observe(target));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-doc-toc')) customElements.define('s-doc-toc', SDocToc);
